// for hrms
import React, { useState } from 'react';
//import { Link } from 'react-router-dom';
import { Card, CardContent, CardFooter } from "./card";
import { Button } from "./button";
import { Briefcase, MapPin, Clock, Users } from "lucide-react";
import '../../pages/styles/Career.css';

const JobCard = ({ job }) => {
  return (
    <Card className="job-card">
      <CardContent className="job-card-content">
        <h3 className="job-title">{job.title}</h3>
        
        <div className="job-meta-details">
          <div className="job-meta-item">
            <MapPin className="job-meta-icon" />
            <span>{job.location}</span>
          </div>
          
          <div className="job-meta-item">
            <Briefcase className="job-meta-icon" />
            <span>{job.jobType}</span>
          </div>
          
          <div className="job-meta-item">
            <Clock className="job-meta-icon" />
            <span>{job.custom_experience}</span>
          </div>
          
          {/* <div className="job-meta-item">
            <Users className="job-meta-icon" />
            <span>{job.openPositions || 1} Open {(job.openPositions || 1) > 1 ? 'Positions' : 'Position'}</span>
          </div>*/}
        </div>
        
        <p className="job-description">
          {job.description}
        </p>
        
        <div className="job-skills">
          {job.skills.slice(0, 3).map((skill, index) => (
            <span key={index} className="job-skill-tag">
              {skill}
            </span>
          ))}
          {job.skills.length > 3 && (
            <span className="job-skill-more">
              +{job.skills.length - 3} more
            </span>
          )}
        </div>
      </CardContent>
      
      <CardFooter className="job-card-footer">
        <a href={job.detailUrl} className="job-action-link" target="_blank" rel="noopener noreferrer">
          <Button 
            variant="outline" 
            className="job-action-button"
          >
            View Details
          </Button>
        </a>
        
        <a href={job.applyUrl} className="job-action-link" target="_blank" rel="noopener noreferrer">
          <Button 
            variant="outline"
            className="job-action-button apply-button"
          >
            Apply Now
          </Button>
        </a>
      </CardFooter>
    </Card>
  );
};

export default JobCard;
